import React from 'react';
import GroupSelectList from './GroupSelectList';
import FeedSelectList from './FeedSelectList';

const SideBarMenu = () => {
  return (
    <div className="flex flex-col w-full gap-2">
      <FeedSelectList />
      <GroupSelectList />
    </div>
  );
};

export default SideBarMenu;
